/**
 * Constants that define the type of gradient on text.
 * @static
 * @constant
 * @name TEXT_GRADIENT
 * @memberof PIXI
 * @type {object}
 * @property {number} LINEAR_VERTICAL Vertical gradient
 * @property {number} LINEAR_HORIZONTAL Linear gradient
 */
export enum TEXT_GRADIENT
// eslint-disable-next-line @typescript-eslint/indent
{
    LINEAR_VERTICAL = 0,
    LINEAR_HORIZONTAL = 1
}
